module.exports = __webpack_public_path__ + "img/Group1-en.d473c266.png";